import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useCaseHistory } from "@/hooks/useCaseHistory";
import { EmptyHistory, CaseList } from "@/components/history/views";
import Disclaimer from "@/components/Disclaimer";
import { Button } from "@/components/ui/button";
import { Stethoscope, ArrowLeft, Loader2, Download } from "lucide-react";

export default function HistoryPage() {
  const { user } = useAuth();
  const { cases, openId, detail, loadingDetail, exportingAll, toggle, remove, downloadPdf, exportAll } = useCaseHistory(user?.name);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Disclaimer />
      <header className="border-b border-zinc-200 px-5 sm:px-8 py-3.5 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <div className="h-8 w-8 rounded-md bg-[#002FA7] flex items-center justify-center">
            <Stethoscope className="h-4 w-4 text-white" />
          </div>
          <span className="font-serif text-lg tracking-tight text-zinc-900">Medical CDSS</span>
        </div>
        <Link to="/workflow" data-testid="back-to-workflow">
          <Button variant="outline" size="sm" className="border-zinc-300"><ArrowLeft className="h-4 w-4 mr-2" /> Workflow</Button>
        </Link>
      </header>

      <main className="flex-1 px-5 sm:px-8 lg:px-12 py-8 lg:py-10 max-w-4xl w-full">
        <div className="flex items-start justify-between gap-4 flex-wrap">
          <div>
            <h1 className="font-serif text-3xl sm:text-4xl tracking-tight text-zinc-900">Case history</h1>
            <p className="mt-2 text-sm text-zinc-500">Saved cases for {user?.name}. Only cases you explicitly saved are stored.</p>
          </div>
          {cases && cases.length > 0 && (
            <Button onClick={exportAll} disabled={exportingAll} data-testid="export-all-cases-btn" variant="outline" className="border-[#002FA7] text-[#002FA7] hover:bg-blue-50 shrink-0">
              {exportingAll ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Download className="h-4 w-4 mr-2" />}
              Export all (PDF)
            </Button>
          )}
        </div>

        {cases === null && (
          <div className="flex items-center gap-2 text-zinc-500 mt-10"><Loader2 className="h-5 w-5 animate-spin" /> Loading…</div>
        )}

        {cases && cases.length === 0 && <EmptyHistory />}

        {cases && cases.length > 0 && (
          <CaseList
            cases={cases} openId={openId} detail={detail} loadingDetail={loadingDetail}
            onToggle={toggle} onRemove={remove} onDownload={downloadPdf}
          />
        )}
      </main>
    </div>
  );
}
